// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton___qMeP","unreadBadge":"styles_unreadBadge__3IBCK","modalContent":"styles_modalContent__2MzNm","modal":"styles_modal__2o25K"};